export type ExportValueType = string[] | boolean | number | string | undefined;
export type ItemMap = Record<string, ExportValueType>;

export const getItemRow = (
  itemMap: ItemMap,
  itemTypes: string[]
): ExportValueType[] => itemTypes.flatMap(itemType => itemMap[itemType]);
